import { StockSymbol } from '@benzinga/session';

/**
 * Returns a display-friendly company name for ticker hover/headers:
 * prefers short name when available, otherwise full name, or symbol.
 */
export function getTickerDisplayName(
  fullName: string | undefined,
  shortName: string | undefined,
  symbol: StockSymbol,
): string {
  if (shortName?.trim()) {
    return shortName.trim();
  }
  if (fullName?.trim()) {
    return fullName.trim();
  }
  return symbol;
}
